









































































































import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Cguidance extends Vue {
  // tab选中的栏
  activeName = "0";
  tabList0 = [
    {
      name: "应用开发工程师",
      list: {
        p0:
          "1、具有良好汇编语言和C语言的编程能力，掌握gcc/make等相关开发工具；",
        p1: "2、精通ARM架构；",
        p2: "3、掌握x86架构及熟悉常用迁移工具；",
        p3: "4、熟悉常用数据库相关技术。"
        //p4:
        //'5、熟悉常用Web开发框架，如Spring，Struts2等，了解前沿技术，如Spring boot/Spring cloud/nosql/Angular/vue；',
        //p5: '6、熟悉常用数据库相关技术如MySQL，Redis；',
        //p6:
        //'7、熟悉云计算技术的相关开发，如Docker，DevOps，Kubernetes，OpenShift等。'
      }
    },
    {
      name: "应用迁移工程师",
      list: {
        p0:
          "1、具有良好汇编语言和C语言的编程能力，掌握gcc/make等相关开发工具；",
        p1: "2、精通ARM架构；",
        p2: "3、掌握x86架构及熟悉常用迁移工具；",
        p3: "4、熟悉常用数据库相关技术。"
        //p4: '5、熟悉Shell，以及对应的网络服务器编程和编程框架。'
      }
    },
    {
      name: "云服务开发工程师",
      list: {
        p0:
          "1、具有良好汇编语言和C语言的编程能力，掌握gcc/make等相关开发工具；",
        p1: "2、精通ARM架构；",
        p2: "3、掌握x86架构及熟悉常用迁移工具；",
        p3: "4、熟悉常用数据库相关技术。"
        //p4: '5、熟悉Shell，以及对应的网络服务器编程和编程框架。'
      }
    }
  ];
  // 运维类
  tabList1 = [
    {
      name: "硬件运维工程师",
      list: {
        p0:
          "1、具有良好的Java、Python等语言的开发能力，快速开发前后端的各项功能；",
        p1: "2、能够应用开发语言调用鲲鹏API及框架；",
        p2: "3、熟悉嵌入式Linux系统下的开发和调试。"
        //p3:
        //'4、熟悉云计算环境下的新型网络及系统技术，能根椐不同网络环境，对信息安全项目进行规划和设计；',
        // p4:
        //'5、熟练使用linux操作系统，能够熟练在linux环境下配置数据库、web服务器等环境；',
        //p5:
        //'6、具备良好的文档编写习惯与能力，良好的沟通能力和表达能力，精通Word、Excel、PPT等办公软件的使用。'
      }
    },
    {
      name: "云服务运维工程师",
      list: {
        p0:
          "1、具有良好的Java、Python等语言的开发能力，快速开发前后端的各项功能；",
        p1: "2、能够应用开发语言调用鲲鹏API及框架；",
        p2: "3、熟悉嵌入式Linux系统下的开发和调试。"
      }
    },
    {
      name: "云应用运维工程师",
      list: {
        p0:
          "1、具有良好的Java、Python等语言的开发能力，快速开发前后端的各项功能；",
        p1: "2、能够应用开发语言调用鲲鹏API及框架；",
        p2: "3、熟悉嵌入式Linux系统下的开发和调试。"
      }
    }
  ];
  // 解决方案类
  tabList2 = [
    {
      name: "项目经理",
      list: {
        p0: "1、具有ARM产品的软件开发和调试经验；",
        p1: "2、熟悉软件安装调试等基本操作。"
        //p2:
        //'3、熟悉Linux、Unix、WindowsServer等服务器操作及服务器上的Shell；',
        //p3: '4、熟悉一种高级开发语言，例如Java、C#、Python或者Go语言；',
        //p4:
        //'5、精通主流数据库的维护（如Oracle、MySQL、PostgreSQL、GP等），熟悉NoSQL和NewSQL数据维护；',
        //p5: '6、熟悉Docker、Kubernetes等容器及编排框架，熟悉OpenStack。'
      }
    },
    {
      name: "系统集成工程师",
      list: {
        p0: "1、具有ARM产品的软件开发和调试经验；",
        p1: "2、熟悉软件安装调试等基本操作。"
        //p2: '3、熟悉Openstack平台、并对KVM、Ceph、MySQL熟悉了解；',
        // p3:
        //'4、具有较扎实的网络基础，了解各厂家（H3C、CISCO、华为）交换机、防火墙、VPN的大概配置；能够跟客户进行技术交流和方案制作；',
        // p4: '5、对存储的DAS、NAS、SAN原理有一定了解；',
        //p5: '6、熟悉专线申请、测试和故障处理流程；',
        //p6: '7、具备IDC机房实施、机房电力、综合布线的能力；',
        //p7:
        //'8、熟练使用Office相关软件（包括：Word、Excel、PowerPoint、Visio、Project），具有较强的文档能力。'
      }
    },
    {
      name: "实施工程师",
      list: {
        p0: "1、具有ARM产品的软件开发和调试经验；",
        p1: "2、熟悉软件安装调试等基本操作。"
        //p2: '3、熟悉Openstack平台、并对KVM、Ceph、MySQL熟悉了解；',
        // p3:
        //'4、具有较扎实的网络基础，了解各厂家（H3C、CISCO、华为）交换机、防火墙、VPN的大概配置；能够跟客户进行技术交流和方案制作；',
        // p4: '5、对存储的DAS、NAS、SAN原理有一定了解；',
        //p5: '6、熟悉专线申请、测试和故障处理流程；',
        //p6: '7、具备IDC机房实施、机房电力、综合布线的能力；',
        //p7:
        //'8、熟练使用Office相关软件（包括：Word、Excel、PowerPoint、Visio、Project），具有较强的文档能力。'
      }
    }
  ];
  // 云运维
  tabList3 = [
    {
      name: "市场营销经理",
      list: {
        p0: "1、熟悉鲲鹏相关基础知识及鲲鹏常见应用技术架构；",
        p1: "2、了解鲲鹏常见应用场景及其场景解决方案；",
        p2: "3、熟悉鲲鹏产品及其业务、功能与服务。"
        //p3:
        //'4、熟悉局域网的维护及网络安全知识，可熟练进行局域网的搭建和网络设备的基本维护和故障处理；',
        //p4:
        //'5、熟悉Windows Server、linux操作系统，能够对服务器进行维护与管理。'
      }
    },
    {
      name: "市场客户经理",
      list: {
        p0: "1、熟悉鲲鹏相关基础知识及鲲鹏常见应用技术架构；",
        p1: "2、了解鲲鹏常见应用场景及其场景解决方案；",
        p2: "3、熟悉鲲鹏产品及其业务、功能与服务。"
        //p3:
        //'4、熟悉网络、应用、数据库、存储等各层面的负载均衡和高可用技术；',
        //p4:
        //'5、熟悉Nagios、Cacti、Zabbix等至少一种主流监控软件的优化或二次开发；',
        //p5: '6、熟悉ELK,Redis集群,MySQL集群,Kafka集群等集群化管理；',
        //p6: '7、熟悉Ansible、Puppet、Chef等至少一种自动化运维工具。'
      }
    },
    {
      name: "行业解决方案工程师",
      list: {
        p0: "1、熟悉鲲鹏相关基础知识及鲲鹏常见应用技术架构；",
        p1: "2、了解鲲鹏常见应用场景及其场景解决方案；",
        p2: "3、熟悉鲲鹏产品及其业务、功能与服务。"
        //p3:
        //'4、具备脚本编写能力，掌握常用脚本语言（Shell，Python，perl）中的一种或多种；',
        //p4:
        //'5、了解Zabbix，Ganglia，Ansible，Puppet，SaltStack等运维监控和部署工具；',
        //p5: '6、了解LVS，Nginx，Proxy，CDN等web端技术，熟悉TCP/IP协议。'
      }
    },
    {
      name: "产品经理",
      list: {
        p0: "1、熟悉鲲鹏相关基础知识及鲲鹏常见应用技术架构；",
        p1: "2、了解鲲鹏常见应用场景及其场景解决方案；",
        p2: "3、熟悉鲲鹏产品及其业务、功能与服务。"
        //p3: '4、了解网络系统的架构规划、设计、建设和维护；',
        //p4:
        //'5、熟悉以太网工作原理，了解网络基本概念，对OSI七层模型、TCP/IP网络模型；',
        //p5:
        //'6、熟悉各种网络路由和交换技术，能够规划设计、维护多协议、多出口、多业务的网络结构和路由策略；',
        //p6: '7、了解业界主流前沿技术，如SDN，NFV等。'
      }
    },
    {
      name: "售前/售后工程师",
      list: {
        p0: "1、熟悉鲲鹏相关基础知识及鲲鹏常见应用技术架构；",
        p1: "2、了解鲲鹏常见应用场景及其场景解决方案；",
        p2: "3、熟悉鲲鹏产品及其业务、功能与服务。"
        //p3: '4、了解网络系统的架构规划、设计、建设和维护；',
        //p4:
        //'5、熟悉以太网工作原理，了解网络基本概念，对OSI七层模型、TCP/IP网络模型；',
        //p5:
        //'6、熟悉各种网络路由和交换技术，能够规划设计、维护多协议、多出口、多业务的网络结构和路由策略；',
        //p6: '7、了解业界主流前沿技术，如SDN，NFV等。'
      }
    }
  ];
}
